import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from '../styles.module.css'

export function SubscriptionErrorMsg() {
  return (
    <h5 className={styles.subscriptionBoxTitle}>
      <FormattedMessage id="error.default" />
    </h5>
  )
}
